export const Logo = ({ color, width, height }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width || "auto"}
      height={height || "auto"}
      viewBox="0 0 841.000000 339.000000">
      <g transform="translate(-841.000000,339.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
        <path
          d="M6108 2993 c-3 -395 -3 -398 -26 -435 -30 -48 -99 -82 -152 -75 -22
                3 -72 25 -112 51 -97 60 -195 103 -287 127 -453 117 -919 -86 -1137 -495 -87
                -164 -117 -285 -116 -476 0 -112 4 -152 25 -232 93 -356 350 -621 702 -724
                127 -37 329 -44 465 -16 395 81 700 386 781 777 17 84 19 152 19 993 l0 902
                -80 0 -79 0 -3 -397z m-634 -488 c160 -43 261 -101 382 -220 104 -103 163
                -194 205 -320 121 -359 -12 -752 -324 -959 -151 -100 -279 -139 -457 -140
                -128 0 -199 12 -312 56 -140 53 -296 176 -381 299 -55 80 -108 208 -129 308
                -25 120 -20 277 12 391 45 157 149 317 273 420 87 72 241 146 352 170 107 24
                283 21 379 -5z"
        />
        <path
          d="M897 2689 c-113 -12 -218 -43 -332 -99 -250 -122 -438 -347 -522
-625 -25 -84 -27 -103 -27 -270 0 -166 2 -187 27 -266 37 -120 68 -189 132
-284 135 -204 333 -345 581 -417 69 -20 100 -23 254 -22 161 0 182 3 265 28
278 84 501 269 625 520 59 120 87 218 99 347 28 299 -75 587 -288 800 -168
168 -372 264 -612 289 -56 5 -106 9 -113 9 -6 -1 -46 -5 -89 -10z m279 -178
c252 -52 471 -224 580 -456 62 -133 78 -206 78 -360 0 -171 -31 -289 -115
-433 -51 -85 -209 -238 -299 -289 -341 -190 -752 -129 -1019 152 -233 246
-293 608 -153 918 40 87 82 148 161 231 200 208 483 296 767 237z"
        />
        <path
          d="M3035 2690 c-332 -37 -623 -236 -780 -533 -205 -389 -127 -874 191
-1177 130 -124 274 -205 444 -252 74 -20 107 -23 255 -22 141 0 183 4 247 22
94 26 212 79 298 135 56 37 71 42 121 42 62 0 94 -17 133 -69 20 -26 21 -43
26 -429 l5 -402 83 -3 82 -3 0 884 c0 768 -2 896 -16 978 -38 220 -134 399
-298 557 -210 201 -507 304 -791 272z m325 -190 c229 -64 424 -226 525 -435
68 -141 80 -195 79 -375 0 -147 -2 -160 -32 -250 -91 -274 -306 -476 -587
-551 -112 -30 -297 -30 -410 0 -302 80 -534 316 -606 616 -18 76 -20 110 -16
220 5 145 20 214 73 324 118 251 341 420 622 471 78 15 268 4 352 -20z"
        />
        <path
          d="M7297 2689 c-115 -12 -219 -43 -332 -99 -497 -245 -699 -850 -449
-1343 172 -339 509 -546 890 -547 130 0 197 11 320 51 256 84 468 273 586 525
63 136 90 255 91 409 0 72 -5 157 -12 190 -93 451 -441 768 -892 815 -56 5
-106 9 -113 9 -6 -1 -46 -5 -89 -10z m283 -179 c167 -34 343 -136 447 -258
137 -160 199 -314 210 -517 11 -237 -73 -457 -239 -624 -281 -282 -710 -329
-1042 -114 -321 208 -459 604 -337 968 79 236 274 433 511 517 139 49 299 59
450 28z"
        />
      </g>
    </svg>
  );
};
